import React from 'react';
import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

const searchQueryId = {
  search_query_id: window.Livewire?.request?.searchQuery?.id,
};
// eslint-disable-next-line camelcase
const common = (query, page, filter_wires) => ({
  params: query ? {
    query, page, filter_wires, ...searchQueryId,
  } : searchQueryId,
});

export default function useGetSearchWiresSimilar(query, filterWires) {
  const [state, q] = useAxios({
    cache: { ignoreCache: true },
    url: '/api/v1/wires/similar',
    method: 'GET',
    ...common(query, 1, filterWires),
  }, { manual: true });
  const executeQuery = React.useCallback(
    page => q(common(query, page, filterWires)),
    [q, query, filterWires],
  );
  return [state, executeQuery];
}
